import { z } from 'zod';
import { AddressSchema } from '@/schemas/models/address';
import { ErrorResponseSchema } from '@/schemas/common/base';

/**
 * GET /api/addresses response schema
 * Returns a list of addresses for the authenticated user
 */
export const GetAddressesResponseSchema = z.discriminatedUnion('success', [
  z.object({
    success: z.literal(true),
    addresses: z.array(AddressSchema),
  }),
  ErrorResponseSchema,
]);

export type GetAddressesResponse = z.infer<typeof GetAddressesResponseSchema>;
